import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { LicenceHolder } from '@lib/shared/models/licence.model';
import { User } from '@lib/shared/models/user.model';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

import { LoginContext } from './authentication/authentication.service';
import { environment } from '@lib/environments/environment';

interface CreateAccountResponse {
  licenceId: string;
}

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  public user$: BehaviorSubject<User> = new BehaviorSubject(null);
  public licence$: BehaviorSubject<LicenceHolder> = new BehaviorSubject(null);
  public signUpMethod$: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(
    private auth: AngularFireAuth,
    private fns: AngularFireFunctions,
  ) {}

  public async createAccount(): Promise<CreateAccountResponse> {
    await this.createFirebaseAuth({
      username: this.user$.value.email,
      password: this.user$.value.password,
    });

    const appName = environment.appType === 'pe' ? 'pePro' : 'outdoorPro';
    return await firstValueFrom(
      this.fns.httpsCallable<
        { appName: string; name: string; licenceHolder: LicenceHolder },
        CreateAccountResponse
      >('createAccount')({
        appName,
        name: this.user$.value.name,
        licenceHolder: this.licence$.value,
      }),
    );
  }

  private async createFirebaseAuth(context: LoginContext): Promise<void> {
    await this.auth.createUserWithEmailAndPassword(context.username, context.password);
  }
}
